<template>
  <mv-default-row class="mb-5">
    <v-layout row wrap>
      <v-flex xs12 hidden-sm-and-down class="py-4">
        <v-divider></v-divider>
      </v-flex>
      <v-flex xs12 md4 d-flex>
        <v-card flat color="transparent">
          <v-card-text>
            <strong>Транспортная карта
            </strong>
            <br/>
            <br/>
            <p>
              МБУ "ЦДС ГПТ"
              <br/>
              <a href="https://cdsvyatka.com" target="_blank">cdsvyatka.com</a>
              <br/>
              Адрес: Киров, ул. Пятницкая 2-а
              <br/>
              <br/>
            </p>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 md4 d-flex>
        <v-card flat color="transparent">
          <v-card-text>
            <strong>Консультационный центр</strong>
            <br/>
            <br/>
            <p>
              <a href="tel:8-8332-485-999">
                <span>тел. 485-999 (многоканальный)</span>
              </a>
            </p>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 md4 d-flex>
        <v-card flat color="transparent">
          <v-card-text>
            <strong>Техническая поддержка
            </strong>
            <br/>
            <br/>
            <template v-if="profile">
              <a href="/#/support">задать вопрос через сайт</a>
              <br/>
              <br/>
            </template>
            Электронный адрес:
            <a href="mailto:info-karta@cds43.ru">info-karta@cds43.ru</a>
            <br/>
            <br/>
            <div style="float:left;">
              Группа VK &nbsp;
            </div>
            <a href="https://vk.com/ekarta43" target="_blank">
              <img src="@/assets/socialvk.png" width="24" >
            </a>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </mv-default-row>
</template>

<script>
export default {
  name: 'site-footer',
  computed: {
    profile () {
      return this.$store.state.profile
    }
  }
}
</script>

<style lang="css" scoped>
  .brand {
    color: inherit;
    text-decoration: none;
    font-size: 14px;
    font-weight: bold;
  }
</style>
